import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/layuot/sideBar.css';
import logo from '../../logoMin.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars,
    faHouse,
    faSignInAlt,
    faUser,
    faPlusCircle,
    faFolderOpen,
    faUpload,
    faBell
} from '@fortawesome/free-solid-svg-icons';
import NotificationPopup from "../projects/NotificationPopup";
import axios from "axios";
import Modal from "../base/Modal";
import NotificationsDropdown from "../base/NotificationsDropdown";
import vars from "../../vars";



function SidebarSTD(props) {
    const navigate = useNavigate();
    const [popupMessage, setPopupMessage] = useState(null);
    const [department, setDepartment] = useState(null);
    const [showNotifications, setShowNotifications] = useState(false);


    const handleLogout = async () => {
        try {
            const response = await fetch(`${vars.apiUrl}/apiStudent/logout`, {
                method: 'POST',
                credentials: 'include',
            });

            if (response.ok) {
                setPopupMessage({ message: "התנתקת בהצלחה", type: "success" });
                setTimeout(() => {
                    navigate('/students');
                }, 2000);
            } else {
                setPopupMessage({ message: "שגיאה בהתנתקות", type: "error" });
            }
        } catch (error) {
            console.error('Logout failed:', error);
            setPopupMessage({ message: "שגיאה בהתנתקות", type: "error" });
        }
    };

    useEffect(() => {
        async function fetchDepartment() {
            try {
                const res = await axios.get(`${vars.apiUrl}/departments/std`, { withCredentials: true });
                if (res.data && res.data.data) {
                    setDepartment(res.data.data);
                }
            } catch (err) {
                console.error("שגיאה בטעינת המגמה:", err);
            }
        }

        fetchDepartment();
    }, []);


    const buttons = [
        { icon: faHouse, label: 'בית', page: '/students/HomeStudent' },
        { icon: faSignInAlt, label: 'התנתקות', action: 'logout', onClick: handleLogout },
        { icon: faUser, label: 'פרופיל', page: '/students/profile' },
        { icon: faPlusCircle, label: 'הוסף פרויקט', page: '/students/upload' },
        { icon: faFolderOpen, label: 'הפרויקטים שלי', page: '/students/MyProjects' },
        { icon: faUpload, label: 'העלה קובץ', page: '/students/UpFile' },
    ];


    const handleNavigate = (page) => {
        navigate(page);
    };

    return (
        <aside className="sidebar">
            <div className="left">
                <h2>תפריט</h2>
                <div className="spacer"></div>
                <button disabled>
                    <FontAwesomeIcon icon={faBars} />
                </button>
                {department && (
                    <h2 style={{ marginTop: 'auto', textAlign: 'center',}}> {department.name}</h2>
                )}
                <img src={logo} alt="Logo" className="side-logo-min" />
            </div>

            <div className="right">
                <img src={logo} alt="Logo" className="side-logo" />

                <nav className="buttons">
                    {buttons.map((btn, index) => (
                        <button key={index} onClick={btn.onClick || (() => handleNavigate(btn.page))}>
                            <FontAwesomeIcon icon={btn.icon} />
                            <span>{btn.label}</span>
                        </button>
                    ))}
                </nav>
                <div className="notifications-section">
                    <button className="notifications-button"  onClick={() => setShowNotifications(true)}>
                        <FontAwesomeIcon icon={faBell} />
                        <span>התראות</span>
                    </button>
                </div>
            </div>

            {showNotifications && (
                <Modal onClose={() => setShowNotifications(false)} width="40vw">
                    <NotificationsDropdown
                        onClose={() => setShowNotifications(false)}
                    />
                </Modal>
            )}


            {popupMessage && <NotificationPopup message={popupMessage.message} type={popupMessage.type} />}
        </aside>
    );
}

export default SidebarSTD;
